<template>
  <div class="common-bg-plate">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'CommonBgPlate'
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme('common-bg-plate', (
  --cbaas-bg-plate-background-color: #232D51,
    --cbaas-bg-plate-border-color: #232D51
), (
  --cbaas-bg-plate-background-color: #fff,
  --cbaas-bg-plate-border-color: #fff
));
.common-bg-plate {
  @include adaptation((
    --cbaas-bg-plate-border-width: 0px
  ));

  background: var(--cbaas-bg-plate-background-color);
  border: var(--cbaas-bg-plate-border-width) solid var(--cbaas-bg-plate-border-color);
  height: 100%;
  min-height: var(--base-main-router-body-avaliable-height-with-action-bar);
}
</style>
